import src from "IMAGE";
export default { src, width: 3353, height: 2427, blurWidth: 0, blurHeight: 0};
